import React, { useState, useEffect } from 'react';
import { Table, Empty } from 'antd';

import {
    MoreOutlined
} from '@ant-design/icons';

import {Action} from 'fennec-ui'
import {DropdownAction} from 'fennec-ui'
import AddAdminOrg from '../AddAdminOrg'
import { GET, errorCatch } from 'fennec-ui'

export default function AdminOrg(props) {
    const { auth, object } = props;

    const [loading, setLoading] = useState(false);
    const [adminList, setAdminList] = useState([]);

    useEffect(() => {
        auth.fetch(`/api/org/admin/list/${object.ID}`).then(res => {
            if (res && res.data) {
                setAdminList(res.data);
            }
        });
    }, []);

    const admin_delete = (admin) => {
        setLoading(true);
        GET(auth, `/api/delete/org/admin/${admin.ID}`,
            () => {
                setLoading(false);
                var k = [...adminList];
                k.splice(k.findIndex(e => e.ID === admin.ID), 1);
                setAdminList(k);
            },
            (err) => errorCatch(err));
    };
    const columns = () => {
        var c = [];
        c.push({
            title: 'Пользователь',
            render: (text, record) => {
                return (
                    <div>
                        {record.user.lastname + " " + record.user.firstname}
                    </div>
                );
            },
            key: 'user',
        });
        c.push({
            title: 'Email',
            render: (text, record) => {
                return (
                    <div>
                        {record.user.email}
                    </div>
                );
            },
            key: 'email',
        });
        c.push({
            title: '',
            dataIndex: '',
            key: 'x',
            fixed: 'right',
            width: 45,
            render: (text, record) => {
                return (
                    <DropdownAction icon={<MoreOutlined />} buttonStyle={{ border: "none" }} items={[
                        {
                            title: "Удалить",
                            mode: "MenuItem",
                            action: () => admin_delete(record)
                        }
                    ]} />
                );
            },
        });

        return c;
    };
    const addAdminOrg = (values, unlock, close) => {
        setLoading(true);
        GET(auth, `/api/add/org/${object.ID}/admin/${values.user.ID}`,
            ({ data }) => {
                setLoading(false);
                if (data) {
                    setAdminList([...adminList, data]);
                }
                close();
            },
            (err) => errorCatch(err, ()=>{
                unlock();
                setLoading(false);
            }));
    };
    return (
        <>
            <Action //{...props}
                readonly={false}
                triggerStyle={{ marginBottom: "5px" }}
                triggerOptions={{
                    type: "primary",
                    loading: loading
                }}
                auth={auth}
                action={addAdminOrg}
                form={AddAdminOrg}
                title={"Добавить администратора"}
                modal={{
                    // width: "55%",
                    minWidth: "400px",
                }}
                mode={"button"}
            />
            <Table
                loading={loading}
                columns={columns()}
                pagination={false}
                dataSource={adminList}
                locale={{ emptyText: <Empty description={"Нет администраторов"}></Empty> }}
                size="small"
                rowKey={(r) => r.ID} />
        </>
    );
}
